import { render, staticRenderFns } from "./waldo-alert-match.vue?vue&type=template&id=245b2e3c"
import script from "./waldo-alert-match.vue?vue&type=script&lang=js"
export * from "./waldo-alert-match.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports